import { isSSRServer } from '@/config';
import { numberFormat, formatUnitsNumber } from '@/common/format';
export const SELECT_SPLIT = ',';
export const RANGE_SPLIT = ',';
export const CHECKBOX_SPLIT = ',';
export const TAG_INPUT_SPLIT = ',';
export const SAVE_SEARCH_STATUS = {
    save: 'SAVE',
    search: 'SEARCH',
    listing: 'LISTING'
};

export const LAYOUT_LIST = [
    { label: 'list', value: 'normal' },
    { label: 'mixed', value: 'mixed' },
    { label: 'map', value: 'map' },
]

export function isHideMobileOutFields(theme) { 
    return ['broker', 'layout1'].includes(theme)
}
export const OUTSIDE_FIELDS = ['location']

export const DATA_TYPE_MAP = {
    year: 'year',
    sqft: 'sqft',
    money: 'money',
    float: 'float',
    days: 'days',
    date: 'date',
    none: 'none'
};

export function getRecentlySearch() {
    if (!isSSRServer) {
        try {
            const sessionStorage = window.sessionStorage;
            const recentlySearch = sessionStorage.getItem('recently_search');
            if (recentlySearch) {
                return JSON.parse(decodeURIComponent(recentlySearch));
            } else {
                return [];
            }
        } catch (e) {
            console.log(e);
        }
    }
    return [];
}

export function setRecentlySearch(search) {
    if (!isSSRServer) {
        try {
            const sessionStorage = window.sessionStorage;
            sessionStorage.setItem(
                'recently_search',
                `${encodeURIComponent(JSON.stringify(search))}`
            );
        } catch (e) {
            console.log(e);
        }
    }
}

export function setRecentlyPropertyType(property) {
    if (!isSSRServer) {
        try {
            const localStorage = window.localStorage;
            localStorage.setItem(
                'recently-property-type',
                JSON.stringify(property)
            );
        } catch (e) {
            console.log(e);
        }
    }
}

export const selectLabels = (config, value) => {
    const labels = [];
    const values = value.split(SELECT_SPLIT);
    let option = {};
    if (config.args) {
        config.args.reduce((memo, cur) => {
            return (option[cur.value] = cur.label);
        }, option);
    }
    values.forEach(v => {
        option[v] && labels.push(option[v]);
    });
    return labels;
};

export const rangeLabels = (config, value = '', { currencySymbol }) => {
    const format = (v, units) => {
        if (config.mask === 'money') {
            if (units) {
                return currencySymbol + formatUnitsNumber(v);
            }
            return `${currencySymbol} ` + numberFormat(v, false);
        }
        return numberFormat(v, false);
    };
    let v = value.split(RANGE_SPLIT);
    const values = { 0: v[0] || '', 1: v[1] || '' };
    let minLabel = config?.args?.minLabel || '';
    let maxLabel = config?.args?.maxLabel || '';
    return [
        values[0]
            ? minLabel.replace('${value}', format(values[0], true), true)
            : '',
        values[1]
            ? maxLabel.replace('${value}', format(values[1], true), true)
            : ''
    ];
};

export function mapFormat(mask) {
    switch (mask) {
    case 'money':
        return 'dollar';
    case 'year':
        return 'year';
    case 'float':
        return 'one_decimal';
    default:
        return 'number';
    }
}

const ignoreTags = ['mapPath', 'mapSearch', 'mapRadius', 'key'];

export function getIgnoreTags({ theme, outsideFields }) { 
    //  ignored by mobile tag filter
    if (isHideMobileOutFields(theme)) {
        return [...ignoreTags];
    } else {
        return [
            ...ignoreTags,
            ...outsideFields.slice(0, 3)
        ];
    }
}

// 中台
export function getTagFilterCenter({ isMobileSize, theme, outFields = OUTSIDE_FIELDS }) {
    if (isMobileSize && isHideMobileOutFields(theme)) {
        return [...ignoreTags];
    } else {
        return [
            ...ignoreTags,
            ...outFields
        ];
    }
}
export function getMoreFieldsCenter({ isMobileSize, theme, outsideFields = [] }) { 
    let mobileLen = isHideMobileOutFields(theme) ? 0 : 3;
    let len = isMobileSize ? mobileLen : 4;
    return outsideFields.slice(0, len);
}

export const conditionMapCenter = {
    suggestion: 'suggestion',
    singleSelect: 'singleSelect',
    multipleSelect: 'multiSelect',
    inputBox: 'inputBox',
    text: 'text',
    keyWord: 'keyWord',
    checkBox: 'checkBox',
    SelectButtonGroup: 'SelectButtonGroup',
    RangeButtonGroup: 'RangeButtonGroup',
}

export function getPropsByConditionCenter({ data, inMore = false, siteId, theme }) {
    let { inputType, label, name, options, componentType } = data
    let props = { label, kee: name, inputType, theme, componentType }
    switch (inputType) {
    case conditionMapCenter.suggestion:
        props = { ...props, data, inMore, siteId }
        break;
    case conditionMapCenter.singleSelect:
    case conditionMapCenter.multipleSelect:
    case conditionMapCenter.SelectButtonGroup:
        props = { ...props, options, inMore }
        if (inputType === conditionMapCenter.multipleSelect) {
            props.multiple = true  
        }
        break;
    case conditionMapCenter.inputBox:
        props = { ...props, data, inMore, wrapStyle: {} }
        break;
    case conditionMapCenter.text:
    case conditionMapCenter.keyWord:
    case conditionMapCenter.RangeButtonGroup:
        props = { ...props, data, inMore }
        break;
    case conditionMapCenter.checkBox:
        props = { ...props, inMore }
        break;
    }
    return props
}


// 非中台
export const OUT_FIELDS = [
    'minPrice-maxPrice',
    'More-Than-Beds',
    'More-Than-Baths',
    'Property-Type',
    // 'purchaseType-For-Sale-Rent'
];
export const getOutFields = ({ theme, isMobileSize }) => { 
    switch (theme) {    
    case 'layout1':
        return isMobileSize ? [] : OUT_FIELDS;
    case 'broker':
        return isMobileSize ? [] : OUT_FIELDS.slice(0, 3);
    default:
        return OUT_FIELDS.slice(0, 3);
    }
}
export function getTagFilter({ isMobileSize, theme, outFields = OUTSIDE_FIELDS }) {
    if (isMobileSize && isHideMobileOutFields(theme)) {
        return [...ignoreTags];
    } else {
        return [
            ...ignoreTags,
            ...outFields
        ];
    }
}
export function filterOptions({ translateFn, isMobileSize, args, force, kee }) {
    if (isMobileSize && args) {
        let argsWithoutEmpty = args.filter(arg => arg.value);
        if (argsWithoutEmpty.length < 3) {
            translateFn?.({ options: args, name: kee });
        }
        return (argsWithoutEmpty.length < 6 || force) ? argsWithoutEmpty : args;
    } else {
        return args;
    }
}

const conditionTypeName = {
    checkBox: 1,
    range: 2,
    singleSelect: 3,
    multipleSelect: 4,
    tagInput: 8,
};
const inputTypeMap = {
    [conditionTypeName.checkBox]: 'checkBox',
    [conditionTypeName.range]: 'range',
    [conditionTypeName.singleSelect]: 'singleSelect',
    [conditionTypeName.multipleSelect]: 'multiSelect',
    [conditionTypeName.tagInput]: 'tagInput',
}
export const getType = key => {
    return inputTypeMap[conditionTypeName[key]]
}

export function getPropsByCondition({ data, inMore = false, isMobileSize, translateFn, theme }) {
    let { type, kee, label, args, mask, icon, options = [] } = data;
    type = Number(type);
    let ret = { conditionType: type, kee, label, theme };
    if (inMore) {
        ret.inMore = true;
    }
    const inputType = inputTypeMap[type]
    switch (inputType) {
    case getType('checkBox'):
        break;
    case getType('range'):
        Object.assign(ret, { args });
        if (inMore) {
            Object.assign(ret, {
                icon,
                mask: mapFormat(mask)
            });
        } else {
            // dropdown: 在下拉框中展示范围选择框
            Object.assign(ret, { dropdown: true, mask });
        }
        break;
    case getType('singleSelect'):
    case getType('multipleSelect'):
        Object.assign(ret, {
            itemHeight: 40,
            multiple: type === 4,
            type: isMobileSize ? 'input' : 'dropdown',
            options
        });
        if (inMore) {
            Object.assign(ret, {
                type: 'input',
                options: filterOptions({ translateFn, isMobileSize, args, kee })
            });
        } else {
            Object.assign(ret, { options: args });
        }
        break;
    case getType('tagInput'):
        Object.assign(ret, { args });
        break;
    }

    return ret;
}

export const PRIMARY_KEYS_MAP = {
    purchasetype: {
        initName: 'purchaseType',
        componentType: 'TabRadio', // singleSelect
        hideOutFilter: true,
        groupType: 'field',
        hideGroupTitle: true
    },
    price: {
        initName: 'price',
        // componentType: 'priceRangeSelect', // inputBox
        groupType: 'field'
    },
    beds: {
        initName: 'beds',
        componentType: 'RangeButtonGroup', // inputBox
        groupType: 'field',
        hideGroupTitle: true
    },
    baths: {
        initName: 'baths',
        // componentType: 'RangeButtonRadio', // inputBox
        componentType: 'RangeButtonGroup', // inputBox
        groupType: 'field',
        hideGroupTitle: true
    },
    listingstatus: {
        initName: 'listingStatus',
        componentType: 'SelectButtonGroup', // multiSelect
        groupType: 'field',
        hideGroupTitle: true
    },
    propertytype: {
        initName: 'propertyType',
        componentType: 'SelectButtonGroup', // multiSelect
        groupType: 'field',
        hideGroupTitle: true
    },
}

export const getPrimaryKeysMap = () => {
    Object.keys(PRIMARY_KEYS_MAP).forEach(key => {
        let { initName } = PRIMARY_KEYS_MAP[key]
        if (initName) {
            PRIMARY_KEYS_MAP[key].name = initName.toLowerCase()
        }
    })
    return PRIMARY_KEYS_MAP
}

export function getPrimaryOutsideFieldsCenter({ primaryKeysMap = {}, searchData, isMobile }) {
    let primaryOutsideFields = []
    let primaryKeys = Object.values(primaryKeysMap).filter(value => !value.hideOutFilter).map(value => value.initName);
    let map = {}
    if (primaryKeys.length) {
        searchData.forEach(config => {
            let { conditions } = config;
            for (let i = conditions.length - 1; i >= 0; i--) {
                let condition = conditions[i];
                let { name } = condition
                if (name && primaryKeys.includes(name)) {
                    !isMobile && (map[name] = name.toLowerCase())
                }
            }
        })
    }
    primaryOutsideFields = primaryKeys.filter(key => map[key]).map(v => v.toLowerCase())
    return {
        isFillOutsideFields: !isMobile && primaryOutsideFields.length < 4,
        primaryOutsideFields: primaryOutsideFields.slice(0, 4)
    }
}

export function updateSearchListCenter({ primaryKeysMap = {}, searchData }) {
    searchData = JSON.parse(JSON.stringify(searchData));

    let groups = {}
    let primaryKeys = Object.keys(primaryKeysMap);
    searchData.forEach(config => {
        let { conditions } = config;
        for (let i = conditions.length - 1; i >= 0;) {
            let condition = conditions[i];
            let { name, label } = condition
            if (OUTSIDE_FIELDS.includes(name)) {
                conditions.splice(i, 1)
            } else if (primaryKeys.includes(name)) {
                let { componentType, hideGroupTitle, groupType } = primaryKeysMap[name]
                groups[name] = { name: label, hideGroupTitle, groupType, conditions: [{ ...condition, componentType }] }
                conditions.splice(i, 1)
            }
            i--
        }
    })
    searchData.unshift(...primaryKeys.map(name => groups[name]).filter(Boolean))

    searchData = searchData.filter(item => item.conditions && item.conditions.length > 0)
    return searchData
}